export default __webpack_public_path__ + "static/media/egs.3633b2b7.png";